module.exports = __webpack_public_path__ + "img/bulle_2_choix_metier.4fce4b40.png";